// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const latios: PokeData = {
  "id": 381,
  "name": "latios",
  "height": 20,
  "weight": 600,
  "base_experience": 270,
  "types": [
    PokeType.DRAGON,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "confusion",
    "psychic",
    "recover",
    "psywave",
    "protect",
    "safeguard",
    "dragon-breath",
    "memento",
    "helping-hand",
    "refresh",
    "luster-purge",
    "dragon-dance",
    "tailwind",
    "psycho-shift",
    "heal-block",
    "dragon-pulse",
    "zen-headbutt",
    "power-split",
    "telekinesis",
    "simple-beam",
    "stored-power",
    "ally-switch",
    "heal-pulse"
  ],
  "moves": [
    "psychic",
    "psywave",
    "protect",
    "dragon-breath",
    "refresh",
    "dragon-dance",
    "tailwind",
    "dragon-pulse",
    "zen-headbutt",
    "psy-pulse",
    "healing-wish",
    "dragon-vortex",
    "draco-meteor"
  ],
  "evolution_chain": {
    "id": 197,
    "item": null,
    "species": [
      {
        "name": "latios",
        "order": 411,
        "types": [
          PokeType.DRAGON,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 107,
    "speed": 134,
    "ability_power": 159
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
